import { render, staticRenderFns } from "./MongastonStats.vue?vue&type=template&id=5472083e&scoped=true&"
import script from "./MongastonStats.vue?vue&type=script&lang=js&"
export * from "./MongastonStats.vue?vue&type=script&lang=js&"
import style0 from "./MongastonStats.vue?vue&type=style&index=0&id=5472083e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5472083e",
  null
  
)

export default component.exports